import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../constants/colors";

export default makeStyles((theme) => ({
  footer: {
    position: "sticky",
    top: "100%",
    height: "50px",
    color: `${COLORS.primary}`,
    width: "100%",
    backgroundColor: `${COLORS.accent}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "15px",
    fontFamily: "Blinker",
    fontSize: 18,
    fontWeight: 700,
    "@media(max-width:600px)":{
      fontSize: 12
    }
  },
  link: {
    textDecoration: "none",
    color: `${COLORS.primary}`,
    "&:hover": {
      color: `${COLORS.primary}`,
    },
  },
}));
